import { LineItem } from "@/utils/types/types";

export const parseLineItem = (lineItem: LineItem) => {
  const data = lineItem.itemJson?.cartData || {};
  const price = Number(lineItem.itemJson.price || "0");
  const quantity = lineItem.quantity || 0;
  return {
    title: data.staticField1,
    quantity,
    price,
    totalPrice: price * quantity,
    size: data.staticField2,
    type: data.staticField3,
    subtype: data.staticField4,
    conditionalFields: (data.conditionalFields || []) as string[],
    mats: [
      data.materialsField1,
      data.materialsField2,
      data.materialsField3,
      data.materialsField4,
      data.materialsField5,
      data.materialsField5_5,
      data.materialsField6,
      data.materialsField7,
      data.materialsField8,
      data.materialsField9,
      data.materialsField10,
    ].filter(el => !!el),
  };
};
